export default __webpack_public_path__ + "static/media/claro-1.2f8dd1f9.JPG";